import { createSelector } from "reselect";

const selectEntity = state => state.entities.question_answer_option;
const selectEntityData = state =>
  state.entities.question_answer_option
    ? state.entities.question_answer_option.data || {}
    : {};

export const makeSelectQuestionAnswerOptions = () =>
  createSelector([selectEntityData, selectEntity], (substate, e) => {
    return substate;
  });

export const makeSelectIsQuestionAnswerOptionsLoading = () =>
  createSelector(selectEntity, substate => {
    if (substate) return substate.isLoading;
  });
